import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/',
    redirect: '/login' // 默认重定向到登录页
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginPage.vue')
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    component: () => import(/* webpackChunkName: "changePwd" */ '../views/ChangePwd.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomePage.vue'),
    meta: { requiresAuth: true }, // 添加路由元信息，标记需要登录才能访问
    children: [
      {
        path: '', // 默认子路由
        redirect: '/home/report'
      },
      {
        path: 'question',
        name: 'question',
        component: () => import(/* webpackChunkName: "question" */ '../views/QuestionList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'order',
        name: 'order',
        component: () => import(/* webpackChunkName: "order" */ '../views/OrderList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'report',
        name: 'report',
        component: () => import(/* webpackChunkName: "report" */ '../views/ReportList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'reportDetail/:orderNo',
        name: 'reportDetail',
        component: () => import(/* webpackChunkName: "reportDetail" */ '../views/ReportDetail.vue'),
        meta: { requiresAuth: true },
        props: true
      },
      {
        path: 'regCheck',
        name: 'regCheck',
        component: () => import(/* webpackChunkName: "regCheck" */ '../views/RegCheckList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'config',
        name: 'config',
        component: () => import(/* webpackChunkName: "config" */ '../views/ConfigPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'repAnswers/:orderNo',
        name: 'repAnswers',
        component: () => import(/* webpackChunkName: "repAnswers" */ '../views/ReportAnswers.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'organization',
        name: 'organization',
        component: () => import(/* webpackChunkName: "organization" */ '../views/OrgList.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*', // 404 页面
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 页面切换时滚动到顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // 清除可能的残留数据
  const cleanAuthData = () => {
    localStorage.removeItem('isLogin')
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }

  // 检查 token 有效性
  function checkTokenValidity () {
    if (!token) {
      return false
    }
    // 这里可以添加更复杂的验证逻辑，例如解析 JWT 检查过期时间等
    // 简单示例：检查 token 是否存在
    return true
  }

  if (requiresAuth) {
    if (!token) {
      cleanAuthData()
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      // 检查 token 有效性
      const tokenValid = checkTokenValidity()
      if (!tokenValid) {
        cleanAuthData()
        ElMessage.error('登录已过期，请重新登录')
        next('/login')
      } else {
        next()
      }
    }
  } else if (to.path === '/login' && token) {
    next('/home')
  } else {
    next()
  }
})

export default router
